var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('information-box',{attrs:{"is-welcome":_vm.isWelcome,"title-tag":_vm.isWelcome ? 'h2' : 'h3',"clusters-list":_vm.clusters,"category-name":_vm.translations[13439]},on:{"search-cluster":_vm.searchCluster}})
}
var staticRenderFns = []

export { render, staticRenderFns }